module.exports = __webpack_public_path__ + "static/img/6.813720b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/6.png
// module id = sqPO
// module chunks = 0